// @ts-nocheck
/* eslint-disable */
export const noFilterIcon = {
    data: `<svg viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M8.05798 8.57275V13L9.27537 11.7826V8.57275L13.3333 3.66667H6.00002M2.66669 2L12.9217 14.1186" stroke="#ea3959" stroke-width="0.666667"/></svg>`,
    name: 'no-filter' as const
};